var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c("div", { staticClass: "item-service" }, [
        _c("ul", [
          _c("li", [
            _c(
              "div",
              {
                staticClass:
                  "has-icon add-icon add-transfer-night d-flex justify-content-between"
              },
              [
                _c("div", [
                  _c("p", [_vm._v("Notte in transito")]),
                  _vm._v(" "),
                  _c("small", [
                    _vm._v("check-" + _vm._s(_vm.isCheckOut ? "out" : "in"))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "tools" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn info",
                      on: {
                        click: function($event) {
                          return _vm.onClickInfo(_vm.item)
                        }
                      }
                    },
                    [_c("div")]
                  )
                ])
              ]
            )
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3073cdc9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3073cdc9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/common/itinerario/ItemTransferNight.vue
// module id = null
// module chunks = 